module.exports = __webpack_public_path__ + "img/github.7f6e2993.svg";